export interface Tip {
  id: string;
  bgcolor: string;
  imgUrl1x: string;
  imgUrl2x: string;
  langs?: string[];
  url: string;
}

const tips: Tip[] = [
  {
    id: 'guide-1',
    bgcolor: '#FAF3C0',
    imgUrl1x: require('images/tips/guide-1@1x.png'),
    imgUrl2x: require('images/tips/guide-1@2x.png'),
    url:
      'https://trello.com/guide?utm_source=trello&utm_medium=inapp&utm_content=header-tips&utm_campaign=guide',
  },
  {
    id: 'inspiration-1',
    bgcolor: '#298FCA',
    imgUrl1x: require('images/tips/inspiration-1@1x.png'),
    imgUrl2x: require('images/tips/inspiration-1@2x.png'),
    langs: ['en-US', 'en-GB', 'en-AU', 'fr', 'pt-BR'],
    url:
      'https://trello.com/inspiration?utm_source=trello&utm_medium=inapp&utm_content=header-tips&utm_campaign=inspiration',
  },
  {
    id: 'power-ups-1',
    bgcolor: '#42548E',
    imgUrl1x: require('images/tips/power-ups-1@1x.png'),
    imgUrl2x: require('images/tips/power-ups-1@2x.png'),
    url:
      'https://trello.com/power-ups?utm_source=trello&utm_medium=inapp&utm_content=header-tips&utm_campaign=power-ups',
  },
  {
    id: 'webinars-1',
    bgcolor: '#42548E',
    imgUrl1x: require('images/tips/webinars-1@1x.png'),
    imgUrl2x: require('images/tips/webinars-1@2x.png'),
    url:
      'https://trello.com/webinars?utm_source=trello&utm_medium=inapp&utm_content=header-tips&utm_campaign=webinar',
  },
];

export default tips;



// WEBPACK FOOTER //
// ./app/common/data/tips.ts